import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
import FitType from './FitType';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class DynamicImageFitCriteria {
	constructor(props){
		const {fitType} = props;
		this._fitType = fitType;
	}
	get fitType(){
		return this._fitType;
	}
	get fitWidth(){
		return this._fitType===FitType.WIDTH;
	}
	get fitHeight(){
		return this._fitType===FitType.HEIGHT;
	}
}